import { render, staticRenderFns } from "./manage-access-filter.vue?vue&type=template&id=39189f8c"
import script from "./manage-access-filter.vue?vue&type=script&lang=js"
export * from "./manage-access-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports